<template>

    <div>

        <h1 class="mt-4">Offertformulär</h1>

        <div class="content-container">

            <div class="row g-3 mb-4">

                <div class="col-24 col-md-6">
                    <input type="text"
                           class="form-control new-list-group-field"
                           placeholder="Sök namn, kontaktuppgifter, övriga fält"
                           v-model="settings.query.text"
                    >
                </div>

                <div class="col-24 col-md-6">
                    <select
                           class="form-control new-list-group-field"
                           v-model="settings.query.mode"
                    >
                        <option :value="null">Typ</option>
                        <option value="quotation">Beställning</option>
                        <option value="contact">Kontaktförfrågan</option>
                    </select>
                </div>

            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col col-2">
                            <span>{{ props.item.id }}</span>
                        </div>
                        <div class="col col-3">
                            <span v-if="props.item.created_at">{{ props.item.created_at.substring(0,10) }}</span>
                        </div>
                        <div class="col col-3">
                            <span>{{ props.item.contract_name }}</span>
                        </div>
                        <div class="col col-4">
                            <span>{{ props.item.contract_email }}</span>
                        </div>
                        <div class="col col-3">
                            <span>{{ props.item.company_name }}</span>
                        </div>
                        <div class="col col-3">
                            <span v-if="props.item.mode == 'contact'">Kontaktförfrågan</span>
                            <span v-else>Beställning</span>
                        </div>
                        <div class="col col-2">
                            <span v-if="!props.item.price">Ej offert</span>
                            <span v-else>{{ props.item.price }} kr</span>
                        </div>
                        <div class="col col-1">
                            <img src="/images/check.png" style="width:22px;" v-if="props.item.processed_at">
                        </div>
                        <div class="col col-3 d-flex justify-content-end">
                            <button class="btn btn-secondary btn-sm me-2" :disabled="props.item.processed_at" @click="process(props.item.id)">Klar</button>

                            <a :href="'/quotationsNew/'+props.item.id">
                                <button class="btn btn-primary btn-sm">Visa allt</button>
                            </a>

                        </div>
                    </div>
                </div>
            </list>
        </div>
    </div>

</template>

<script>

import lister from '../../shared/mixins/lister'
import axios from 'axios'

export default {

    mixins: [
        lister
    ],

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {

            settings: {
                url: '/quotationsNew/list',
                query: {
                    text: '',
                    mode: null
                },
                columns: [
                    { column: 'id', name: 'Id', class: 'col col-2', sortable: true, default: true },
                    { column: 'created_at', name: 'Inkommen', class: 'col col-3', sortable: true },
                    { column: 'contract_name', name: 'Namn', class: 'col col-3', sortable: true },
                    { column: 'contract_email', name: 'E-post', class: 'col col-4', sortable: true },
                    { column: 'company_name', name: 'Företag', class: 'col col-3', sortable: true },
                    { column: 'mode', name: 'Typ', class: 'col col-3', sortable: true },
                    { column: 'price', name: 'Pris', class: 'col col-2', sortable: true },
                    { column: 'processed_at', name: 'Klar', class: 'col col-1', sortable: true }
                ],
                bulk_actions: [],
                export_fields: []
            }
        }
    },

    methods: {
        process (quotation_id) {
            axios.patch('/quotationsNew/' + quotation_id + '/process')
                .then(response => {
                    this.refresh()
                })
        }
    }
}
</script>
